import { render, staticRenderFns } from "./CsvEtiquetasCrud.vue?vue&type=template&id=15bc45f0&"
import script from "./CsvEtiquetasCrud.vue?vue&type=script&lang=js&"
export * from "./CsvEtiquetasCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports